import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 * Fires when the user navigates forward or back in the revamp reviews
 * carousel — either by clicking the stepper arrows or by swiping/scrolling.
 * `direction` is derived from the page index delta: `forward` when the new
 * page index is greater than the previous one, `back` otherwise.
 *
 * &nbsp;
 */
export class SitterProfileReviewCarouselScrollEvent extends AnalyticsEvent {
  eventName = 'sitter-profile-review-carousel-scroll';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;
}
